import React, { useState } from 'react'
import './index.scss'
import moment from 'moment'
import ParticleOverlay from '../particle-overlay'
import { userHasPro } from '../../../../../lib/util'
import ProBlocker from '../../pro-blocker'

const DisplayDaily = props => {
  const { forcast, position, ideal, user, toggleProModal } = props,
    [selected, selectDay] = useState(0),
    isPro = userHasPro(user),
    days = forcast.filter((entry, idx) => entry.isDay || (!entry.isDay && idx === 0)),
    getCompassDirection = (deg) => {
      if (deg <= 22.5) {
        return 'N'
      }
      else if (Math.abs(45 - deg) < 22.5) {
        return 'NE'
      }
      else if (Math.abs(90 - deg) <= 22.5) {
        return 'E'
      }
      else if (Math.abs(135 - deg) < 22.5) {
        return 'SE'
      }
      else if (Math.abs(180 - deg) <= 22.5) {
        return 'S'
      }
      else if (Math.abs(225 - deg) < 22.5) {
        return 'SW'
      }
      else if (Math.abs(270 - deg) <= 22.5) {
        return 'W'
      }
      else if (Math.abs(315 - deg) < 22.5) {
        return 'NW'
      } else {
        return 'N'
      }
    },
    isIdeal = (direction, ideal) => {
      const dirMap = { n: 0, ne: 45, e: 90, se: 135, s: 180, sw: 225, w: 270, nw: 315 },
        idealDegs = ideal.map(idealStr => dirMap[idealStr])
      if (ideal.indexOf('n') !== -1) {
        idealDegs.push(360)
      }
      const hasIdeal = idealDegs.some(deg => Math.abs(deg - direction) < 22.5),
        hasRisky = idealDegs.some(deg => Math.abs(deg - direction) <= (45 - 12.25))
      return hasIdeal ? 'ideal' : hasRisky ? 'risky' : 'bad'
    },
    makeEntries = () => {
      // const days = forcast.filter((entry, idx) => entry.isDay || (!entry.isDay && idx === 0))
      return days.map((day, idx) => {
        const dayStr = moment.utc(day.timeStamp).local().format('ddd'),
          { direction, speed } = day,
          dirStr = getCompassDirection(direction),
          idealStr = isIdeal(direction, ideal)
        return (
          <div className='hunt-daily-row'
            style={{
              backgroundColor: selected === idx ? '#4f4f4f' : ''
            }}
            onClick={() => {
              if (isPro || idx < 1) {
                selectDay(idx)
              } else {
                toggleProModal()
              }
            }}
            key={day.timeStamp}>
            <div style={{ width: '16.5%', paddingTop: '20px' }}>{dayStr}</div>
            {
              (isPro || idx < 1) ? (
                <div className={`hunt-daily-${idealStr}`} style={{
                  transform: `rotate(${direction}deg)`
                }}></div>) : null
            }
            {
              (isPro || idx < 1) ? (<div style={{ width: '16.5%', paddingTop: '20px' }}>{dirStr}</div>) : null
            }
            {
              (isPro || idx < 1) ? (<div style={{ width: '16.5%', paddingTop: '20px' }}>{`${speed}mph`}</div>) : null
            }
            {
              (isPro || idx < 1) ? (<div style={{ width: '16.5%', paddingTop: '20px' }}>{`${speed}mph`}</div>) : null
            }
            {
              (isPro || idx < 1) ? (
                <div style={{
                  width: '16.5%',
                  paddingTop: '20px',
                  textTransform: 'capitalize',
                  color: idealStr === 'ideal' ? '#589500' : idealStr === 'risky' ? 'yellow' : 'red'
                }} >{idealStr}</div>) : null
            }
            {
              (!isPro && idx > 0) ? (
                <div style={{ width: '80%', position: 'relative' }}>
                  <ProBlocker center={true} clickHandler={toggleProModal} />
                </div>
              ) : null
            }
          </div >
        )
      })
    }
  return (
    <div>
      {makeEntries()}
      {forcast ? <ParticleOverlay position={position} speed={days[selected].speed} direction={days[selected].direction} />
        : null}
    </div>
  )
}

export default DisplayDaily